const { eventLoader } = window.o_global ?? {};
export {
  eventLoader
};
